// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../node_modules/rescript/lib/es6/array.js";
import * as Caml_array from "../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as IncentiveContent from "./IncentiveContent.bs.js";

function getIncentiveCampaignContent(language, campaign) {
  var state = {
    contents: {
      param_current_value: String(campaign.payout.param_current_value),
      target: String(Caml_array.get($$Array.of_list(campaign.payout.config), List.length(campaign.payout.config) - 1 | 0).target),
      validatorMissed: "",
      missedTarget: "",
      validatorABRTG: "",
      abrtgTarget: "",
      fraudOrdersAllowed: ""
    }
  };
  List.map((function (e) {
          var match = e.validator_name;
          var tmp;
          switch (match) {
            case /* MISSED_ORDER */0 :
                var init = state.contents;
                tmp = {
                  param_current_value: init.param_current_value,
                  target: init.target,
                  validatorMissed: String(e.value),
                  missedTarget: String(e.threshold),
                  validatorABRTG: init.validatorABRTG,
                  abrtgTarget: init.abrtgTarget,
                  fraudOrdersAllowed: init.fraudOrdersAllowed
                };
                break;
            case /* ABRTG */1 :
                var init$1 = state.contents;
                tmp = {
                  param_current_value: init$1.param_current_value,
                  target: init$1.target,
                  validatorMissed: init$1.validatorMissed,
                  missedTarget: init$1.missedTarget,
                  validatorABRTG: String(e.value),
                  abrtgTarget: String(e.threshold),
                  fraudOrdersAllowed: init$1.fraudOrdersAllowed
                };
                break;
            case /* FRAUD_ORDER */2 :
                var init$2 = state.contents;
                tmp = {
                  param_current_value: init$2.param_current_value,
                  target: init$2.target,
                  validatorMissed: init$2.validatorMissed,
                  missedTarget: init$2.missedTarget,
                  validatorABRTG: init$2.validatorABRTG,
                  abrtgTarget: init$2.abrtgTarget,
                  fraudOrdersAllowed: String(e.threshold)
                };
                break;
            
          }
          state.contents = tmp;
          return e;
        }), campaign.validators);
  switch (language) {
    case /* English */0 :
        return IncentiveContent.English.englishCampaign(state.contents);
    case /* Hindi */1 :
        return IncentiveContent.Hindi.hindiCampaign(state.contents);
    case /* Kannada */2 :
        return IncentiveContent.Kannada.kannadaCampaign(state.contents);
    case /* Tamil */3 :
        return IncentiveContent.Tamil.tamilCampaign(state.contents);
    case /* Telugu */4 :
        return IncentiveContent.Telugu.teluguCampaign(state.contents);
    case /* Marathi */5 :
        return IncentiveContent.Marathi.marathiCampaign(state.contents);
    case /* Malayalam */6 :
        throw {
              RE_EXN_ID: "Match_failure",
              _1: [
                "IncentiveContentManager.res",
                46,
                4
              ],
              Error: new Error()
            };
    case /* Bangla */7 :
        return IncentiveContent.Bangla.banglaCampaign(state.contents);
    
  }
}

var Content = {
  getIncentiveCampaignContent: getIncentiveCampaignContent
};

export {
  Content ,
  
}
/* No side effect */
